/* Spring Renaissance · Small Pleasures concepts — shared behaviour.
   1) Ajax add-to-bag for every form[data-sp-buy]: stays on the page, shows "Added · View bag", bumps the header count via the cart:updated event.
   A form with data-sp-items='[{"id":1,"quantity":1},…]' adds several items at once (pairs).
   2) Nothing else global: concept-specific behaviour lives in its own section. */
(function () {
  if (window.__spBaseReady) return;
  window.__spBaseReady = true;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function wire(form) {
    if (form.dataset.spWired) return;
    form.dataset.spWired = '1';
    var btn = form.querySelector('[data-sp-btn]');
    var msg = form.querySelector('[data-sp-msg]');
    var bag = form.dataset.spBagLabel || 'View bag';
    var added = form.dataset.spAdded || 'Added to your bag.';
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!btn || btn.disabled) return;
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = form.dataset.spAdding || 'Adding…';
      if (msg) { msg.hidden = true; msg.classList.remove('sp-buy__msg--err'); }
      var items = form.dataset.spItems ? JSON.parse(form.dataset.spItems) : null;
      fetch(root + 'cart/add.js', items
        ? { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) }
        : { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Could not add to bag.'); return d; }); })
        .then(function () {
          if (msg) { msg.innerHTML = added + ' <a href="' + root + 'cart">' + bag + '</a>'; msg.hidden = false; }
          document.dispatchEvent(new Event('cart:updated'));
        })
        .catch(function (x) {
          if (msg) { msg.textContent = x.message; msg.classList.add('sp-buy__msg--err'); msg.hidden = false; }
        })
        .then(function () { btn.disabled = false; btn.textContent = label; });
    });
  }
  function wireAll() { document.querySelectorAll('form[data-sp-buy]').forEach(wire); }
  window.spWire = wireAll; /* v4: forms added later (the pin sheet) call this */
  wireAll();
  document.addEventListener('shopify:section:load', wireAll);
})();
